import React from 'react';
import { Box, Flex, Heading, Tabs, Button } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { AvatarUploader } from './avatar-uploader';
import { CandidateContactInfo } from './candidate-contact-info';
import { CandidatePersonalInfo } from './candidate-personal-info';
import { CandidateProfileSekelton } from './candidate-profile-sekelton';
import { useUserProfile } from './user-profile.provider';
import { toast } from 'sonner';

const UserProfileTab = {
   PERSONAL_INFO: 'personal_info',
   CONTACT_INFO: 'contact_info',
} as const;
type UserProfileTab = (typeof UserProfileTab)[keyof typeof UserProfileTab];

const UserProfileView = () => {
   const userProfile = useUserProfile();
   const [tab, setTab] = React.useState<UserProfileTab>(UserProfileTab.PERSONAL_INFO);

   React.useEffect(() => {
      userProfile.loadUserProfile();
   }, []);

   const isProfileLoading =
      userProfile.loadUserProfileState.status === 'idle' ||
      userProfile.loadUserProfileState.status === 'pending';

   return (
      <Flex className="candidate-user-profile" direction="column" mb={{ initial: '0', md: '4' }}>
         <Heading as="h2" mb="7" weight="medium">
            {'\u041F\u0440\u043E\u0444\u0456\u043B\u044C:'}
         </Heading>

         <Box
            width="100%"
            minWidth={{
               initial: '100%',
               md: '640px',
            }}
            maxWidth="640px"
         >
            {isProfileLoading ? (
               <CandidateProfileSekelton />
            ) : (
               <Box width="100%">
                  <Box mb="6">
                     <AvatarUploader />
                  </Box>

                  <Tabs.Root value={tab} onValueChange={(value) => setTab(value as UserProfileTab)}>
                     <Tabs.List size="2">
                        <Tabs.Trigger value={UserProfileTab.PERSONAL_INFO}>
                           Особиста інформація
                        </Tabs.Trigger>
                        <Tabs.Trigger value={UserProfileTab.CONTACT_INFO}>
                           Контактна інформація
                        </Tabs.Trigger>
                     </Tabs.List>

                     <Box pt="3">
                        <Tabs.Content value={UserProfileTab.PERSONAL_INFO}>
                           <CandidatePersonalInfo />
                        </Tabs.Content>

                        <Tabs.Content value={UserProfileTab.CONTACT_INFO}>
                           <CandidateContactInfo store={userProfile.candidateContactInfoStore} />
                        </Tabs.Content>
                     </Box>
                  </Tabs.Root>

                  <Flex mt="5" width="100%" justify="end">
                     <Button
                        size="4"
                        radius="small"
                        loading={userProfile.profileSaving}
                        onClick={() => {
                           userProfile.submitProfile({
                              onSuccess: () => {
                                 toast.success('Профіль успішно оновлено');
                              },
                              onError: (message, status) => {
                                 toast.error('Щось пійшло не так, спробуйте пізніше');
                              },
                           });
                        }}
                     >
                        Зберегти
                     </Button>
                  </Flex>
               </Box>
            )}
         </Box>
      </Flex>
   );
};

export const UserProfile = observer(UserProfileView);
